import React from "react";
import "./Qualification.css";
const Qualification = () => {
  return (
    <section className="qualificationWrapper">
      <h1>Educational Credentials:</h1>
      <div className="credBlock">
        <span className="credHead">BS Software Engineering (BSSE):</span> <br />
        <span className="credDesc">
          from- <b> The Orbit Institue</b> affiliate with <b>GCUF</b>
        </span>
      </div>
      <div className="credBlock">
        <span className="credHead">Cloud Computing:</span>
        <span className="credDesc">
          6-Months Certification
        </span>
      </div>
    </section>
  );
};

export default Qualification;
